<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<li :class="twMerge('inline-flex items-center gap-1.5', props.class)">
		<slot />
	</li>
</template>
